import {Component, computed, ChangeDetectionStrategy} from "@angular/core"
import {BaseInspectorComponent} from "@app/template-editor/components/inspectors/base-inspector/base-inspector.component"
import {InspectorSectionComponent} from "@app/template-editor/components/inspectors/inspector-section/inspector-section.component"
import {ValueSlotComponent} from "@app/template-editor/components/value-slot/value-slot.component"
import {ValueLikeNode, getTemplateNodeClassLabel} from "@cm/template-nodes"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-value-inspector",
    templateUrl: "./value-inspector.component.html",
    styleUrl: "./value-inspector.component.scss",
    imports: [InspectorSectionComponent, ValueSlotComponent],
})
export class ValueInspectorComponent extends BaseInspectorComponent<ValueLikeNode> {
    readonly $class = computed(() => getTemplateNodeClassLabel(this.$node()))
}
